import React, { useEffect } from 'react';

import { fetchAuthenticated, get } from 'services/fetch';
import { emitEvent } from 'utils/events';

import EquipmentPackingForm from 'components/forms/EquipmentPackingForm';
import { logAction } from 'utils/logs';

export default function NewEquipmentPacking(props) {
  const { history, setBreadcrumbs } = props;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/exemplares', label: 'Exemplares' },
      { path: '', label: 'Novo Exemplar' }
    ]);
    return () => setBreadcrumbs([]);
  }, [setBreadcrumbs])

  // Handle form submit
  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('post', 'equipment-exemplary', data);

    if (!response.ok) {
      throw new Error('');
    } else {
      const data = await response.json();
      if (data) {
        for (const e of data) {
          logAction(`Criação do exemplar ${e.name}`);
        }
      }
      emitEvent('showSnack', { message: 'Exemplar criado com sucesso', type: 'success' });
      history.push(`/cadastros/exemplares`);
    }
  }

  // Handle cancel click
  const handleCancel = async () => {
    history.push('/cadastros/exemplares');
  }


  return (
    <div>
      <EquipmentPackingForm
        title='Novo Exemplar'
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
      />
    </div>
  )
}
